import type { FaireProductEntity } from "../../entity_types/product";

export const p_z5byx2z2t8: FaireProductEntity = {
  token: "p_z5byx2z2t8",
  type: "product",
  name: "Classic Chunky Knit Baby Sweater Cardigan (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/752af9029d0bb405ba95d72bfb10dbca29865a6486249b6ea068e1250585a7ad.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5be989997fe4ba113c33d9b9e1ec152f3cf39fda4f922f98197301f6980f06f.png",
    "https://cdn.faire.com/fastly/3f3927cdb325bd6a344d57238d5bf174e0a20105ebe3b3be2db8121a128c21b1.jpeg",
    "https://cdn.faire.com/fastly/507b6bfcb87a994138e80cdee10fcc97c19c04f77dc558d8381140c2c1066cf2.jpeg",
    "https://cdn.faire.com/fastly/92f98e9233b3a923f4bdb36e139f954b01c5a2663ecd38ef9f7b1adb1d21c3a0.jpeg",
    "https://cdn.faire.com/fastly/4284cfe261f6782b8949d6ae84f5551a57b0e7130e28d665d8f4cf83f5581c94.jpeg",
    "https://cdn.faire.com/fastly/dc0dc0b525ca18721b59877cee3d989b171101522b90f7f162e6e0d26b0f0f41.jpeg",
    "https://cdn.faire.com/fastly/f689a044fdcddda82496e72c31a2fdbe4c89c818539b32b1d7246695268ed3fe.jpeg",
    "https://cdn.faire.com/fastly/9200ffa6bd4121b21e288cea00e9c0422d50ec35e019446d6e842aba7fcf74cd.jpeg",
  ],
  priceDollars: 26,
  description:
    "100% organic cotton long-sleeve baby cardigan sweater, chunky knit with front button opening.\n\n• Breathable organic cotton, comfy and cozy.\n• Eco-friendly, chemical-free and non-toxic, good for baby's delicate skin.\n• Machine washable, durable and long lasting.\n• Eco-friendly, chemical free, non-toxic, pure, natural & organic baby clothes.\n• Ethically produced in India, supporting better livelihoods for small grower farmers.\n\nViverano, an American brand, was founded in 2013 with the simple idea of producing eco-friendly, pure and organic baby clothes. Viverano baby clothing is known for its soft hand feel and high quality. Pamper your precious babies with our non-toxic, lightweight, all-season, natural baby outfits.\n\nExperience 'Organic Comfort' by Viverano, a family-owned small business.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T05:03:41.505Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
